export interface Testimonial {
  id: string;
  name: string;
  avatarUrl: string;
  rating: number;
  comment: string;
  source: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 't-1',
    name: '小明同学',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Korean%20young%20man%20portrait%2C%20casual%20style%2C%20warm%20lighting%2C%20simple%20clean%20background%2C%20friendly%20expression%2C%20natural%20look&width=160&height=160&seq=avatar-01&orientation=squarish',
    rating: 5.0,
    comment: '这个网站真的太棒了！下拉式阅读体验超级流畅，再也不用点来点去翻页了。而且漫画种类特别全，我喜欢看的韩漫这里都有。已经推荐给身边所有喜欢看漫画的朋友了！',
    source: 'App Store 用户评价',
  },
  {
    id: 't-2',
    name: '漫画控',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Korean%20young%20woman%20portrait%2C%20trendy%20style%2C%20warm%20indoor%20lighting%2C%20simple%20background%2C%20happy%20expression%2C%20natural%20look%2C%20clean%20aesthetic&width=160&height=160&seq=avatar-02&orientation=squarish',
    rating: 5.0,
    comment: '找了好久终于找到一个专门看韩漫的地方！画质高清、更新速度快，最重要的是完全免费！分类也很清晰，查找超方便。每天通勤路上的必备消遣。',
    source: 'Google Play 用户评价',
  },
  {
    id: 't-3',
    name: '深夜读者',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Korean%20man%20portrait%20in%20hoodie%2C%20cozy%20atmosphere%2C%20warm%20dim%20lighting%2C%20simple%20background%2C%20relaxed%20expression%2C%20natural%20look&width=160&height=160&seq=avatar-03&orientation=squarish',
    rating: 4.8,
    comment: '无遮挡的下拉式体验真的太舒适了，可以一口气看几十话完全不累。漫画质量也很高，很多热门韩漫都能第一时间看到更新。收藏功能也特别实用！',
    source: '网站用户反馈',
  },
];

export const stats = [
  { label: '收录漫画', value: '5,000+' },
  { label: '日活跃用户', value: '80万+' },
  { label: '累计阅读', value: '12亿+' },
  { label: '用户好评率', value: '98.6%' },
];